import React, { Fragment, ReactElement } from 'react';
import { useIntl } from 'react-intl';

// Components

import PhoneNumberInfo from '@components/ssap/pages/pageIncludes/summary/summaryIncludes/PhoneNumberInfo';
import SummaryItem from '@components/ssap/pages/pageIncludes/summary/SummaryItem';

// Utils

import { phoneNumberTools } from '@utils/tools/phoneNumberTools';

// Constants

import { PHONE_TYPES } from '@constants/ssap/miscellaneous/miscellaneous';

interface ICommunicationChannelsInfo {
    _phoneExtension: string | null,
    _phoneNumber: string | null,
    emailAddress: string | null,
    phoneExtension: string | null,
    phoneNumber: string | null,
    pcpIndex: number
}

const CommunicationChannelsInfo = (props: ICommunicationChannelsInfo): ReactElement => {

    const {
        _phoneExtension,
        _phoneNumber,
        emailAddress,
        phoneExtension,
        phoneNumber,
        pcpIndex
    } = props;

    const intlApi = useIntl();

    const getPhoneNumberValue = (phoneNumber, extension, phoneType) => {
        const phoneExtension = extension
            ? intlApi.formatMessage(
                { id: 'ssap.final_review.extension' },
                { phoneExtension: extension }
            )
            : ' ';

        return intlApi.formatMessage(
            {
                id: phoneType === PHONE_TYPES.HOME
                    ? 'ssap.final_review.phone_home'
                    : 'ssap.final_review.phone_mobile'
            },
            {
                phoneNumber: phoneNumberTools.getAdjustedPhoneNumber(phoneNumber),
                phoneExtension
            }
        );
    };

    return (
        <Fragment>
            {
                emailAddress &&

                <SummaryItem
                    textCode = 'common.email'
                    value = { emailAddress }
                    ignoreIntl
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].householdContact.contactPreferences.emailAddress`
                            ]
                        ]
                    }
                />
            }

            <PhoneNumberInfo
                value = { getPhoneNumberValue(phoneNumber, phoneExtension, PHONE_TYPES.MOBILE) }
                phoneText = 'common.primary_phone'
                desc = {
                    [
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].householdContact.phone.phoneNumber`,
                                `taxHousehold.householdMember[${ pcpIndex }].householdContact.phone.phoneExtension`
                            ],
                            getPhoneNumberValue,
                            [
                                PHONE_TYPES.MOBILE
                            ]
                        ]
                    ]
                }
            />

            <PhoneNumberInfo
                value = { getPhoneNumberValue(_phoneNumber, _phoneExtension, PHONE_TYPES.HOME) }
                phoneText = 'common.second_phone'
                desc = {
                    [
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].householdContact.otherPhone.phoneNumber`,
                                `taxHousehold.householdMember[${ pcpIndex }].householdContact.otherPhone.phoneExtension`
                            ],
                            getPhoneNumberValue,
                            [
                                PHONE_TYPES.HOME
                            ]
                        ]
                    ]
                }
            />
        </Fragment>
    );
};

export default CommunicationChannelsInfo;